const EmployeeCountGreaterThanLines = 'EmployeeCountGreaterThanLines';
const EmployeeCountLesserThanLines = 'EmployeeCountLesserThanLines';

export default Object.freeze({
    [EmployeeCountGreaterThanLines]: 0,
    [EmployeeCountLesserThanLines]: 1
});

export const ManagerWarningTypeNames = Object.freeze({
    0: EmployeeCountGreaterThanLines,
    1: EmployeeCountLesserThanLines
});

export const ManagerWarningType = Object.freeze({
    EmployeeCountGreaterThanLines: 0,
    EmployeeCountLesserThanLines: 1
});
